import SafetyCertificationList from './SafetyCertificationList';
export default SafetyCertificationList;
